//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
//CONTEXT
import { useCreativeState, useCreativeDispatch } from "../../../../contexts/creative.context";

export function AudioIconPosition() {
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();

  return <>
    <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={4} />
    <div className="relative">
      <ComponentLibrary.PCRadioButtons
        label={"Audio icon position"}
        checked={creative.metadata.icons.audioIconPosition}
        handleChecked={(e: any) => {
          const value = e.target.value;
          creativeDispatch({
            type: "UPDATE_CREATIVE_METADATA_ICONS_AUDIOICONPOSITION",
            payload: { audioIconPosition: value },
          });
        }}
        values={["Left", "Right"]} />
    </div>
    <ComponentLibrary.PCSpacer type={"padding"} position={"bottom"} size={6} />
    <ComponentLibrary.PCSpacer type={"padding"} position={"top"} size={3} />
    <ComponentLibrary.PCDivider width={"w-100"} />
    <ComponentLibrary.PCSpacer type={"padding"} position={"top"} size={4} />
  </>;
}